import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { Trophy } from '@phosphor-icons/react';
import { track } from '@/lib/analytics';
import { competitionVisible, countdownTarget, timeLeft, useCompetition, useNow } from '@/lib/competition';

/** The countdown as "12d 4h 03m". */
function useCountdownText(target: string | undefined): string {
  const { t } = useTranslation('competition');
  const now = useNow(30_000);
  if (!target) return '';
  const left = timeLeft(target, now);
  return t('countdown.short', { d: left.days, h: left.hours, m: String(left.minutes).padStart(2, '0') });
}

/****************
 * THE COMPETITION IN THE TOP BAR. 2026-10-25.
 *
 * Mishka: "un bouton dans le profil, le dashboard ou la top bar". The top bar,
 * because it is on every page: orange, the countdown inside, one press to the
 * competition page. Shown while the competition is upcoming or open; gone once
 * it is over, except for an entrant, who keeps the way to their result.
 ****************/
export function CompetitionHeaderButton() {
  const { t } = useTranslation('competition');
  const navigate = useNavigate();
  const { data: info } = useCompetition();
  const text = useCountdownText(info ? countdownTarget(info) : undefined);
  // Everyone, before it opens too, so they can register (Guillaume, 10-28).
  if (!info || !competitionVisible(info) || (info.phase === 'ended' && !info.entry)) return null;
  return (
    <button
      type="button"
      onClick={() => { track('competition_opened', 'header'); navigate('/competition'); }}
      aria-label={t('header.aria', { time: text })}
      className="competition-glow inline-flex items-center gap-1.5 h-8 px-3 rounded-full text-xs font-semibold whitespace-nowrap text-white bg-orange-500 hover:bg-orange-600 transition-colors"
    >
      <Trophy size={14} weight="fill" />
      <span>{t('header.button')}</span>
      {info.phase !== 'ended' && <span className="hidden md:inline tabular-nums opacity-90">{text}</span>}
    </button>
  );
}
